<div class="container-fluid col-12 p-0 m-0 d-flex flex-md-row flex-lg-row flex-column layout-wrapper">
  <!-- Sidebar -->
  <aside class="menu-area p-0 m-0">
    <app-menu-bar></app-menu-bar>
  </aside>

  <!-- Main column -->
  <main id="cixorMain" class="content-area flex-grow-1 p-0">
    <!-- Decorative Background Pattern -->
    <div class="content-bg-pattern">
      <div class="bg-gradient-orb bg-orb-1"></div>
      <div class="bg-gradient-orb bg-orb-2"></div>
      <div class="bg-gradient-orb bg-orb-3"></div>
      <div class="bg-gradient-orb bg-orb-4"></div>
    </div>

    <!-- Header: sticky (doesn't scroll away) -->
    <header class="content_header">
      <app-top-bar></app-top-bar>
      <hr class="content_divider m-0" />
    </header>

    <!-- Page body (natural flow) -->
    <div class="content_body">
      <app-business-details-bar></app-business-details-bar>
      <router-outlet></router-outlet>
    </div>

    <!-- Page footer: fixed height, after content -->
    <footer class="page_footer">
      <div class="page_footer-inner">
        <span>&copy; {{ currentYear }} CIXOR — All rights reserved. Operated and powered by CIXOR Pvt Ltd.</span>
      </div>
    </footer>
  </main>
</div>
